const lang = {
  contact: 'Contactos',
  experience: 'Experiência Profissional',
  education: 'Educação',
  skills: 'Competências',
  about: 'Sobre mim'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/pt.js